<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>审批详情</p>
      </div>
      <div class="right"></div>
    </div>
    <div class="detail-head">
      <!-- 审批信息 -->
      <div class="approve-wrap">
        <div class="status-tag">
          <img
            v-if="approveData.status === 1"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/wait-l.png"
            width="70"
            height="55"
          />
          <img
            v-if="approveData.status === 2"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-l.png"
            width="70"
            height="55"
          />
          <img
            v-if="approveData.status === 3"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/reject-l.png"
            width="70"
            height="55"
          />
          <img
            v-if="approveData.status === 4"
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/cancel-l.png"
            width="70"
            height="55"
          />
        </div>
        <div
          :class="`approve-title ${
            ['', 'wait', 'pass', 'reject', 'cancel'][approveData.status]
          }`"
        >
          审批信息 - {{ approveData.approval_no }}
        </div>
        <div class="approve-content">
          <div class="rows">
            <div class="row">
              <p class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-s.png"
                  width="18"
                  height="18"
                />
                <span>{{ approveData.initiate_staff.name }}</span>
                <span
                  v-if="
                    approveData.initiate_staff.name === staffName.staff_name
                  "
                  >&nbsp; (我)</span
                >
                <span class="status">发起申请</span>
                <span class="border">|</span>
                <span>{{
                  [
                    "",
                    "购买",
                    "退课",
                    "转课",
                    "购活动",
                    "退单",
                    "退物品",
                    "退服务",
                  ][mainData.order_type]
                }}</span>
              </p>
              <p class="time">发起时间：{{ approveData.create_time }}</p>
            </div>
            <div
              class="row"
              v-for="(item, index) in approveData.approval_staff_list"
              :key="index"
            >
              <p class="title bold">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/wait-s.png"
                  width="18"
                  height="18"
                  v-if="item.sub_status === 1"
                />
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-s.png"
                  width="18"
                  height="18"
                  v-if="item.sub_status === 2"
                />
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/reject-s.png"
                  width="18"
                  height="18"
                  v-if="item.sub_status === 3"
                />
                <span>{{ item.staff.name }}</span>
                <span v-if="item.staff.name === staffName.staff_name"
                  >&nbsp; (我)</span
                >
                <span v-if="item.staff.status === 2 && item.staff.is_del === 2"
                  >&nbsp;(离职)</span
                >
                <span v-if="item.staff.is_del === 1">&nbsp;(删除)</span>
                <span class="mwow-red status" v-if="item.sub_status === 1"
                  >审批中</span
                >
                <span class="mwow-green status" v-if="item.sub_status === 2"
                  >已批准</span
                >
                <span class="mwow-gray status" v-if="item.sub_status === 3"
                  >未批准</span
                >
              </p>
              <p class="time" v-if="item.approval_time">
                审批时间：{{ item.approval_time }}
              </p>
              <p class="desp" v-if="item.remark">审批备注：{{ item.remark }}</p>
            </div>

            <!-- 退款订单order_type === 2|5|6|7，已通过审批approveData.status===2，走新付款流程refund_method>0 -->
            <div
              v-if="
                (mainData.order_type === 2 ||
                  mainData.order_type === 5 ||
                  mainData.order_type === 6 ||
                  mainData.order_type === 7 ||
                  mainData.order_type === 3) &&
                approveData.status === 2 &&
                mainData.refund_method > 0
              "
            >
              <div class="fail-log-wrap" v-if="mainData.refund_fail_log">
                <p>退款失败</p>
                <p>失败时间：{{ mainData.refund_fail_log.create_time }}</p>
                <p>失败原因：{{ mainData.refund_fail_log.reason }}</p>
              </div>
              <!-- 线上支付，退款时后端会判断退款方式，可原路退回时refund_method=1，需要手动退回时refund_method=2，手动转账时需要提交转账凭证 -->
              <div
                class="btns"
                v-if="mainData.status !== 2 && refundHandleDelay"
              >
                <div
                  class="mwow-button-filled success"
                  @click="chooseRefundType"
                >
                  退款处理
                </div>
              </div>
            </div>

            <div
              v-if="
                (mainData.order_type === 2 ||
                  mainData.order_type === 5 ||
                  mainData.order_type === 6 ||
                  mainData.order_type === 7 ||
                  mainData.order_type === 3) &&
                approveData.status === 2 &&
                mainData.refund_method > 0 &&
                voucher_url
              "
              class="row"
            >
              <p class="title bold">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-s.png"
                  width="18"
                  height="18"
                />
                <span>{{ mainData.refund_transfer_staff.name }}</span>
                <span class="mwow-green status">已转账</span>
              </p>
              <p class="time">
                转账时间：<span>{{ mainData.handle_time }}</span>
              </p>
              <p class="desp">
                转账凭证：
                <el-image
                  :src="mainData.refund_transfer.voucher_url"
                  :preview-src-list="[mainData.refund_transfer.voucher_url]"
                >
                </el-image>
              </p>
            </div>
            <!-- <div
              class="row"
              v-if="approveData.status === 4 && approveData.cancel"
            >
              <p class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/cancel-s.png"
                  width="18"
                  height="18"
                />
                <span>{{ approveData.cancel.staff.name }}</span
                ><span class="mwow-yellow status">已撤销</span>
              </p>
              <p class="time">撤销时间：{{ approveData.cancel.cancel_time }}</p>
              <p class="desp">撤销原因：{{ approveData.cancel.remark }}</p>
            </div> -->
          </div>

          <div
            class="btns"
            v-if="
              approveData.status === 1 &&
              approvalAble &&
              mainData.status !== 3 &&
              mainData.status !== 4
            "
          >
            <reject-dialog
              :approval-id="approveData.approval_id"
              @change="init"
            >
              <div class="btn mwow-button-filled danger">拒绝</div>
            </reject-dialog>
            <pass-dialog :approval-id="approveData.approval_id" @change="init">
              <div class="btn mwow-button-filled success">同意</div>
            </pass-dialog>
          </div>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="order-wrap">
        <p
          class="order-title"
          :class="{
            limit: !(mainData.order_id && mainData.approval_id),
          }"
        >
          <span class="text"
            >订单信息 -
            <span
              style="color: #07d1aa; cursor: pointer"
              @click="toOrderDetail('no', mainData.order_no)"
            >
              {{ mainData.order_no }}
            </span>
          </span>
          <span class="payment-status">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/repeal-l.png"
              v-if="mainData.status === 3"
              class="repeal"
              width="70"
              height="55"
            />
            <span v-else>
              {{ handlePaymentStatus() }}
            </span>
          </span>
        </p>
        <div class="order-content">
          <p class="user" v-if="mainData.order_no">
            <span v-if="mainData.order_type === 3">[转出] &nbsp;</span>
            <span class="name">{{ mainData.student.name }}</span
            >{{
              "+" + mainData.student.area_code + " " + mainData.student.mobile
            }}
          </p>
          <p class="user" v-if="mainData.order_type === 3">
            <span>[转入] &nbsp;</span>
            <span class="name">{{ mainData.transfer_join_student.name }}</span
            >{{
              "+" +
              mainData.transfer_join_student.area_code +
              " " +
              mainData.transfer_join_student.mobile
            }}
          </p>
          <!-- 购买 -->
          <div class="form" v-if="mainData.order_type === 1">
            <div class="item">
              <span class="label">业务类型：</span>
              <span class="value">购买</span>
            </div>
            <div class="item">
              <span class="label">收支类型：</span>
              <span class="value">收入</span>
            </div>
            <div class="item">
              <span class="label">应收金额：</span>
              <span class="value">￥{{ mainData.receivable_amount }}</span>
            </div>
            <div class="item">
              <span class="label">实收金额：</span>
              <span class="value">￥{{ mainData.completed_amount }}</span>
            </div>
            <div class="item create-staff">
              <span class="label">创建人：</span>
              <span class="value">{{
                mainData.create_staff && mainData.create_staff.name
              }}</span>
            </div>
            <div class="item">
              <span class="label">业务人员：</span>
              <span class="value">{{
                mainData.belong
                  .map((item) => {
                    return item.name;
                  })
                  .join(",") || "-"
              }}</span>
            </div>
            <div class="item">
              <span class="label">创建时间：</span>
              <span class="value">{{ mainData.create_time }}</span>
            </div>
            <div class="item">
              <span class="label">支付时间：</span>
              <span class="value" v-if="mainData.handle_time !== '-'">
                <span
                  v-if="
                    mainData.create_time.slice(0, 10) !==
                    mainData.handle_time.slice(0, 10)
                  "
                  class="mwow-red"
                  >{{ mainData.handle_time }} (非当天)</span
                >
                <span v-else>{{ mainData.handle_time }}</span>
                <!-- <span>{{ mainData.handle_time }}</span> -->
              </span>
            </div>
            <div class="item">
              <span class="label">其他备注：</span>
              <span class="value">{{ mainData.remark || "-" }}</span>
            </div>
          </div>

          <!-- 退课或退单 -->
          <div
            class="form"
            v-if="
              mainData.order_type === 2 ||
              mainData.order_type === 5 ||
              mainData.order_type === 6 ||
              mainData.order_type === 7
            "
          >
            <div class="item">
              <span class="label">业务类型：</span>
              <span class="value" v-show="mainData.order_type === 2">退课</span>
              <span class="value" v-show="mainData.order_type === 5">退单</span>
              <span class="value" v-show="mainData.order_type === 6"
                >退物品</span
              >
              <span class="value" v-show="mainData.order_type === 7"
                >退服务</span
              >
            </div>
            <div class="item">
              <span class="label">收支类型：</span>
              <span class="value">支出</span>
            </div>
            <div class="item">
              <span class="label">应退金额：</span>
              <span class="value">￥{{ mainData.receivable_amount }}</span>
            </div>
            <div class="item" v-if="mainData.status === 2">
              <span class="label">实退金额：</span>
              <span class="value">￥{{ mainData.completed_amount }}</span>
            </div>
            <div class="item operator">
              <span class="label">操作人员：</span>
              <span class="value">{{
                mainData.create_staff && mainData.create_staff.name
              }}</span>
            </div>
            <div class="item">
              <span class="label">业务人员：</span>
              <span class="value">{{
                mainData.belong
                  .map((item) => {
                    return item.name;
                  })
                  .join(",") || "-"
              }}</span>
            </div>
            <!-- start 退课订单时间控制 -->
            <div class="item">
              <span class="label">创建时间：</span>
              <span class="value">{{ mainData.create_time }}</span>
            </div>
            <div
              class="item"
              v-if="
                (mainData.order_type === 2 ||
                  mainData.order_type === 5 ||
                  mainData.order_type === 6 ||
                  mainData.order_type === 7) &&
                (mainData.status === 2 || mainData.status === 1)
              "
            >
              <!-- 无审批、审批成功、已废除的订单 -->
              <!-- 开通支付审批成功显示，未开通一直显示 -->
              <span class="label">退款时间：</span>
              <span
                class="value"
                v-if="
                  (mainData.order_type === 2 ||
                    mainData.order_type === 5 ||
                    mainData.order_type === 6 ||
                    mainData.order_type === 7) &&
                  (approveData.status === 0 ||
                    approveData.status === 2 ||
                    mainData.status === 3)
                "
              >
                {{ mainData.handle_time ? mainData.handle_time : "-" }}
              </span>
              <span v-else>
                {{ online_pay ? "-" : mainData.handle_time }}
              </span>
            </div>
            <div
              class="item"
              v-if="
                (mainData.order_type === 2 ||
                  mainData.order_type === 5 ||
                  mainData.order_type === 6 ||
                  mainData.order_type === 7) &&
                mainData.status === 4
              "
            >
              <span class="label">取消时间：</span>
              <span class="value">{{
                mainData.cancel_time ? mainData.cancel_time : "-"
              }}</span>
            </div>
            <!-- <div class="item">
              <span class="label">退款时间：</span>
              <span
                class="value"
                v-if="mainData.order_type === 2 && approveData.status === 2"
              >
                {{ mainData.handle_time ? mainData.handle_time : "-" }}
              </span>
              <span v-else> - </span>
            </div> -->
            <div class="item">
              <span class="label">退款原因：</span>
              <span class="value">{{ mainData.remark || "-" }}</span>
            </div>
          </div>

          <!-- 转课 -->
          <div class="form" v-if="mainData.order_type === 3">
            <div class="item">
              <span class="label">业务类型：</span>
              <span class="value">转课</span>
            </div>
            <div class="item">
              <span class="label">收支类型：</span>
              <span class="value">{{
                mainData.payment_type === 1 ? "收入" : "支出"
              }}</span>
            </div>
            <div class="item">
              <span class="label">{{
                mainData.payment_type == 1 ? "应收金额：" : "应退金额："
              }}</span>
              <span class="value">￥{{ mainData.receivable_amount }}</span>
            </div>
            <div class="item" v-show="mainData.payment_type == 1">
              <span class="label">实收金额：</span>
              <span class="value">￥{{ mainData.completed_amount }}</span>
            </div>
            <div
              class="item"
              v-show="mainData.payment_type == 2 && mainData.status === 2"
            >
              <span class="label">实退金额：</span>
              <span class="value">￥{{ mainData.completed_amount }}</span>
            </div>
            <div class="item"></div>
            <div class="item">
              <span class="label">操作人员：</span>
              <span class="value">{{
                mainData.create_staff && mainData.create_staff.name
              }}</span>
            </div>
            <div class="item">
              <span class="label">业务人员：</span>
              <span class="value">{{
                mainData.belong
                  .map((item) => {
                    return item.name;
                  })
                  .join(",") || "-"
              }}</span>
            </div>
            <div class="item">
              <span class="label">转课时间：</span>
              <span class="value">{{ mainData.create_time }}</span>
            </div>
            <div class="item" v-if="mainData.payment_type === 1">
              <span class="label">支付时间：</span>
              <span class="value" v-if="mainData.handle_time !== '-'">
                <span
                  v-if="
                    mainData.create_time.slice(0, 10) !==
                    mainData.handle_time.slice(0, 10)
                  "
                  class="mwow-red"
                  >{{ mainData.handle_time }} (非当天)</span
                >
                <span v-else>{{ mainData.handle_time }}</span>
              </span>
              <span class="value" v-else>-</span>
            </div>
            <div class="item" v-if="mainData.payment_type === 2">
              <span class="label">退款时间：</span>
              <span
                class="value"
                v-if="
                  approveData.status === 0 ||
                  approveData.status === 1 ||
                  approveData.status === 2 ||
                  mainData.status === 3
                "
              >
                {{ mainData.handle_time ? mainData.handle_time : "-" }}
              </span>
              <span class="value" v-else>
                {{ online_pay ? "-" : mainData.handle_time }}
              </span>
            </div>
            <div class="item">
              <span class="label">转课原因：</span>
              <span class="value">{{ mainData.remark || "-" }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单废除 -->
    <!-- <div class="cancel-order-wrap" v-if="mainData.status === 3">
      <p class="title mwow-yellow">订单废除</p>
      <div class="info-box">
        <el-row>
          <p>操作老师：{{ mainData.cancel_log.operate_name }}</p>
          <p>废除原因：{{ mainData.cancel_log.remark }}</p>
          <p>废除时间：{{ mainData.cancel_log.cancel_time }}</p>
        </el-row>
      </div>
    </div> -->
    <!-- 购买 -->
    <div v-if="mainData.order_type === 1">
      <div class="table-wrap">
        <div class="th">
          <div class="td">购买内容</div>
          <div class="td">业务形式</div>
          <div class="td">购买数量</div>
          <div class="td">赠送数量</div>
          <div class="td">直减</div>
          <div class="td">小计</div>
        </div>
        <div class="item" v-for="item in mainData.item" :key="item.item_name">
          <p class="title">
            <span v-show="item.item_type === 1"
              >【{{ item.is_combo ? "套餐" : "课程" }}】</span
            >
            <span v-show="item.item_type === 2">【物品】</span>
            <span v-show="item.item_type === 3">【服务】</span>
            - {{ item.item_name }}
          </p>
          <div class="tr" v-for="it in item.list" :key="it.item_id">
            <div class="td">
              {{ it.item_type === 1 ? "" : it.product_name }}
            </div>
            <div class="td">
              <p v-if="it.business_type === 0">-</p>
              <p v-if="it.business_type === 1">新购</p>
              <p v-if="it.business_type === 2">续费</p>
              <p v-if="it.business_type === 3">拓科</p>
            </div>
            <div class="td">
              {{ Number(it.quantity) }} {{ it.item_type === 1 ? "课时" : "" }}
            </div>
            <div class="td">
              {{ Number(it.give_product_quantity) }}
              {{ it.item_type === 1 ? "课时" : "" }}
            </div>
            <div class="td">
              {{ it.discount_amount === "0.00" ? "0" : it.discount_amount }}
            </div>
            <div class="td">￥{{ it.receivable_amount }}</div>
          </div>
        </div>
      </div>
      <p class="sum-wrap">
        {{ mainData.payment_type === 1 ? "应收金额：" : "应退金额："
        }}<span class="red">￥{{ mainData.receivable_amount }}</span>
      </p>
    </div>
    <!-- 购买end -->
    <!-- 退课 -->
    <div
      v-if="
        mainData.order_type === 2 ||
        mainData.order_type === 5 ||
        mainData.order_type === 6 ||
        mainData.order_type === 7
      "
    >
      <div class="table-wrap">
        <div class="th">
          <div class="td">订单号</div>
          <div class="td">业务形式</div>
          <div class="td">购买内容</div>
          <div class="td">退款数量</div>
          <div class="td">退款金额</div>
          <div class="td">手续费</div>
        </div>
        <div class="item" v-for="item in mainData.item" :key="item.item_name">
          <p class="title">
            <span v-show="item.item_type === 1">
              【{{ item.is_combo ? "套餐" : "课程" }}】
            </span>
            <span v-show="item.item_type === 2">【物品】</span>
            <span v-show="item.item_type === 3">【服务】</span>
            <span v-show="item.item_type === 4">【活动】</span>
            - {{ item.item_name }}
          </p>
          <div class="tr" v-for="it in item.list" :key="it.course_id">
            <div
              class="td"
              style="color: #07d1aa; cursor: pointer"
              @click="toOrderDetail('no', it.relation_order_no)"
            >
              {{ it.relation_order_no }}
            </div>
            <div class="td">
              <p v-if="it.business_type === 0">-</p>
              <p v-if="it.business_type === 1">新购</p>
              <p v-if="it.business_type === 2">续费</p>
              <p v-if="it.business_type === 3">拓科</p>
            </div>
            <div class="td">
              {{ it.spec_name || "￥" + it.spec_unit_price }}
            </div>
            <div class="td">
              {{ Number(it.quantity) }}{{ item.item_type === 1 ? "课时" : "" }}
            </div>
            <div class="td">￥{{ it.amount }}</div>
            <div class="td">￥{{ it.discount_amount }}</div>
          </div>
        </div>
      </div>
      <!-- 只有退课、退单展示 -->
      <!-- v-if="
          (mainData.order_type === 2 || mainData.order_type === 5) &&
          mainData.refund_transfer
        " -->
      <p
        class="sum-wrap"
        v-if="
          mainData.order_type === 2 ||
          mainData.order_type === 5 ||
          mainData.order_type === 6 ||
          mainData.order_type === 7
        "
      >
        {{ mainData.payment_type === 1 ? "应收金额：" : "应退金额："
        }}<span class="red">￥{{ mainData.receivable_amount }}</span>
      </p>
    </div>
    <!-- 退课end -->
    <!-- 转课 -->
    <div v-if="mainData.order_type === 3" class="box1">
      <div v-if="mainData.transferExpenditure" class="box2">
        <div class="table-wrap">
          <div class="th">
            <div class="td">订单号</div>
            <div class="td">业务形式</div>
            <div class="td">购买内容</div>
            <div class="td">单价</div>
            <div class="td">转课课时</div>
            <div class="td">转课金额</div>
            <div class="td" style="margin-right: 20px">手续费</div>
          </div>
          <div
            class="item"
            v-for="item in mainData.transferExpenditure.list"
            :key="item.item_name"
          >
            <p class="title">
              【{{ item.is_combo ? "套餐" : "课程" }}】-
              {{ item.item_name }}
            </p>
            <div class="tr" v-for="it in item.list" :key="it.course_id">
              <template v-if="it.payment_type === 2">
                <div
                  class="td"
                  style="color: #07d1aa; cursor: pointer"
                  @click="toOrderDetail('no', it.relation_order_no)"
                >
                  {{ it.relation_order_no }}
                </div>
                <div class="td">
                  <p v-if="it.business_type === 0">-</p>
                  <p v-if="it.business_type === 1">新购</p>
                  <p v-if="it.business_type === 2">续费</p>
                  <p v-if="it.business_type === 3">拓科</p>
                </div>
                <div class="td">{{ it.spec_name }}</div>
                <div class="td">￥{{ it.spec_unit_price }}</div>
                <!-- 如果是支出类型 退课课时=quantity + give_product_quantity -->
                <div class="td">
                  {{ Number(it.quantity) + Number(it.give_product_quantity) }}
                </div>
                <div class="td">￥{{ it.amount }}</div>
                <div class="td" style="margin-right: 20px">
                  ￥{{ it.discount_amount }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <p class="sum-wrap">
          应退金额：<span class="red"
            >￥{{ mainData.transferExpenditure.receivable_amount }}</span
          >
        </p>
      </div>
      <div v-if="mainData.transferIncome">
        <div class="table-wrap">
          <div class="th">
            <div class="td">购买内容</div>
            <div class="td">业务形式</div>
            <div class="td">转入课时</div>
            <div class="td">赠送课时</div>
            <div class="td">直减</div>
            <div class="td">小计</div>
          </div>
          <div
            class="item"
            v-for="item in mainData.transferIncome.list"
            :key="item.item_name"
          >
            <p class="title">
              【{{ item.is_combo ? "套餐" : "课程" }}】-
              {{ item.item_name }}
            </p>
            <div class="tr" v-for="it in item.list" :key="it.course_id">
              <template v-if="it.payment_type === 1">
                <div class="td">{{ it.spec_name }}</div>
                <div class="td">
                  <p v-if="it.business_type === 0">-</p>
                  <p v-if="it.business_type === 1">新购</p>
                  <p v-if="it.business_type === 2">续费</p>
                  <p v-if="it.business_type === 3">拓科</p>
                </div>
                <div class="td">{{ Number(it.quantity) }}课时</div>
                <div class="td">{{ Number(it.give_product_quantity) }}课时</div>
                <div class="td">
                  {{
                    it.discount_amount === "0.00" ? "0" : it.discount_amount
                  }}课时
                </div>
                <div class="td">￥{{ it.receivable_amount }}</div>
              </template>
            </div>
          </div>
        </div>
        <p class="sum-wrap">
          应收金额：<span class="red"
            >￥{{ mainData.transferIncome.receivable_amount }}</span
          >
        </p>
      </div>
    </div>
    <!-- 转课end -->

    <!-- 收款明细 -->
    <div
      class="collection-detail"
      v-if="mainData.order_type === 1 || mainData.order_type === 4"
    >
      <div class="text">收款明细</div>
      <el-table
        size="mini"
        :data="payDetailDialogData"
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="序号" width="200">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="支付时间" prop="payment_time"></el-table-column>
        <el-table-column label="支付金额" prop="payment_amount">
          <template slot-scope="scope"
            >￥{{ scope.row.payment_amount }}</template
          >
        </el-table-column>
        <el-table-column label="支付方式" prop="payment_name"></el-table-column>
        <el-table-column label="操作人" prop="staff.name"></el-table-column>
      </el-table>
    </div>

    <div class="pay-info" v-show="mainData.refund_method === 0">
      <div class="total-wrap">
        <div class="wrap">
          <div class="part">合计：￥{{ mainData.completed_amount }}</div>
          <div class="part flex">
            <p v-for="item in mainData.payment_list" :key="item.payment_name">
              <span v-if="item.payment_id === 10"
                >乐沃收银（收款机扫客户码）</span
              >
              <span v-else-if="item.payment_id === 7"
                >乐沃收银（客户扫付款码）</span
              >
              <span v-else>{{ item.payment_name }}</span>
              ：￥{{ item.payment_amount }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div
        :class="`mwow-button-filled mini ${
          prevLogId === 0 ? 'disable' : 'primary'
        }`"
        @click="Order(prevLogId)"
      >
        上一份审批
      </div>
      <div class="block"></div>
      <div
        :class="`mwow-button-filled mini ${
          nextLogId === 0 ? 'disable' : 'success'
        }`"
        @click="Order(nextLogId)"
      >
        下一份审批
      </div>
    </div>
    <!-- 退款方式选择 -->
    <el-dialog
      title="退款处理"
      :visible.sync="refundDialogVisible"
      append-to-body
      destroy-on-close
      width="410px"
      class="handle-refund"
    >
      <div>
        <el-form
          size="mini"
          :model="refundDialogForm"
          :rules="cardFormRules"
          ref="cardForm"
          label-width="85px"
          class="refund-form"
        >
          <div class="refund-radio">
            <el-radio-group v-model="refundDialogForm.refund_method">
              <el-radio-button :label="1" :disabled="!refundOriginalSupport">
                原路退回
              </el-radio-button>
              <el-radio-button :label="2">手动转账</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="refundDialogForm.refund_method === 2">
            <div class="refund-reason" v-if="!refundOriginalSupport">
              <div class="reason-item">存在以下原因，无法支持原路退回</div>
              <div class="reason-item">
                <span class="reason-order">1</span>
                在{{ refundReasonDate }}前支付的订单
              </div>
              <div class="reason-item">
                <span class="reason-order">2</span>
                订单支付时间超过360天
              </div>
              <div class="reason-item">
                <span class="reason-order">3</span>
                多次支付的订单或转课的订单
              </div>
            </div>
            <image-uploader
              :originName.sync="voucherDialogForm.image_key"
              :originUrl.sync="voucherDialogForm.image_url"
              :sizeLimit="5"
              accept=".jpeg,.jpg,.png,.gif"
              :showTransferVoucherText="true"
            >
              <div class="voucher-uploader">
                <img
                  v-if="voucherDialogForm.image_url"
                  :src="voucherDialogForm.image_url"
                />
              </div>
            </image-uploader>
          </div>
        </el-form>
      </div>
      <div class="bottom-btns">
        <div
          class="mwow-button"
          style="margin-right: 12px"
          @click="refundDialogVisible = false"
        >
          取消
        </div>
        <div class="mwow-button success" @click="chooseRefundTypeSubmit">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import {
  orderDetail,
  refundOriginalBackApi,
  checkRefundStatusApi,
  uploadRefundVoucherApi,
  getPayment,
  getPaymentDetailApi,
} from "@/api/order";
import rejectDialog from "./rejectDialog.vue";
import passDialog from "./passDialog.vue";
import { approvalAdjoinApi, approvalDetailApi } from "@/api/approve";
import imageUploader from "@/components/imageUploader.vue";
import { PageModule } from "@/store/module/page";
import { UserModule } from "@/store/module/user";
export default {
  components: {
    rejectDialog,
    passDialog,
    imageUploader,
  },
  data() {
    return {
      mainData: {
        student: {},
        payment_list: [],
        handle_time: "",
        refund_transfer: null,
      },
      approveData: {
        initiate_staff: {},
        approval_staff_list: [],
        status: 1,
        type: 1,
      },
      approvalAble: false,
      nextLogId: 0,
      prevLogId: 0,
      staffName: "",
      typeObject: {
        1: "购买",
        2: "退课",
        3: "转课",
      },
      refundDialogVisible: false,
      refundDialogForm: {
        refund_method: 1,
        bank_name: "",
        bank_card: "",
        open_bank: "",
        card_holder_name: "",
      },
      cardFormRules: {
        bank_name: [
          { required: true, message: "请填写银行名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 12) {
                callback(new Error("请输入2-12字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        bank_card: [
          { required: true, message: "请填写银行卡号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 13 || String(value).length > 19) {
                callback(new Error("请输入13-19字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        open_bank: [
          { required: true, message: "请填写开户行", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 24) {
                callback(new Error("请输入2-24字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        card_holder_name: [
          { required: true, message: "请填写持卡人姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 10) {
                callback(new Error("请输入2-10字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      voucherDialogForm: {
        image_key: "",
        image_url: "",
      },
      voucher_url: "",
      refundOriginalSupport: false, // 是否可以原路退回
      online_pay: false, // 是否开通支付
      payDetailDialogData: [],
      refundHandleDelay: false, // 处理退款按钮一闪而过
      refundReasonDate: "",
    };
  },
  created() {
    this.init();
    this.getNearOrder();
    const useInfo = window.localStorage.getItem("userInfo");
    this.staffName = JSON.parse(useInfo);
    getPayment().then((res) => {
      if (res.error_code === 0) {
        this.online_pay = res.data.online_pay;
      }
    });
  },
  watch: {
    $route() {
      this.init();
      this.getNearOrder();
    },
  },
  methods: {
    init() {
      this.refundHandleDelay = false;
      // 获取审批详情
      approvalDetailApi({
        approval_id: this.$route.query.id,
      }).then((res) => {
        res.data.create_time = res.data.create_time
          ? dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(res.data.create_time * 1000)
            )
          : "-";
        res.data.approval_staff_list.map((item) => {
          item.approval_time = item.approval_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(item.approval_time * 1000)
              )
            : "-";
        });
        this.approveData = res.data;
        if (
          res.data.approval_staff_list.findIndex((item) => {
            return (
              item.staff_id === UserModule.userInfo.staff_id &&
              item.sub_status === 1
            );
          }) >= 0
        ) {
          this.approvalAble = true;
        } else {
          this.approvalAble = false;
        }
        //获取订单详情
        this.getOrderDetail(res.data.relation_id);
      });
    },
    getNearOrder() {
      const params = {
        approval_id: Number(this.$route.query.id),
      };
      let cache = {};
      if (this.$route.query.from === "all") {
        cache = PageModule.pageInfo.approveLogAll.search_info;
      }
      if (this.$route.query.from === "mine") {
        cache = PageModule.pageInfo.approveLogMine.search_info;
      }
      if (cache) {
        if (cache.sort_field) {
          params.sort_field = cache.sort_field;
        }
        if (cache.sort_type) {
          params.sort_type = cache.sort_type;
        }
        if (cache.approval_staff_id) {
          params.approval_staff_id = cache.approval_staff_id;
        }
        if (cache.status_arr && cache.status_arr.length >= 0) {
          params.status_arr = cache.status_arr;
        }
        if (cache.approval_no) {
          params.approval_no = cache.approval_no;
        }
        if (cache.student_id) {
          params.student_id = cache.student_id;
        }
        if (cache.type) {
          params.type = cache.type;
        }
        if (cache.initiate_staff_id) {
          params.initiate_staff_id = cache.initiate_staff_id;
        }
        if (cache.copy_staff_id) {
          params.copy_staff_id = cache.copy_staff_id;
        }
        if (cache.handle_status >= 0) {
          params.handle_status = cache.handle_status;
        }
        if (cache.create_time && cache.create_time.length === 2) {
          params.start_date = cache.create_time[0];
          params.end_date = cache.create_time[1];
        }
      }
      // 获取前后审批id
      approvalAdjoinApi(params).then((res) => {
        this.prevLogId = res.data.last_approval_id;
        this.nextLogId = res.data.next_approval_id;
      });
    },
    getOrderDetail(oid) {
      orderDetail({
        order_id: oid,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(res.data.create_time * 1000)
          );
          res.data.cancel_time = res.data.cancel_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.cancel_time * 1000)
              )
            : "-";
          res.data.handle_time = res.data.handle_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.handle_time * 1000)
              )
            : "-";
          // 原订单支付时间
          res.data.original_pay_order_info.handle_time = res.data
            .original_pay_order_info.handle_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.original_pay_order_info.handle_time * 1000)
              )
            : "-";
          // 失败时间
          if (res.data.refund_fail_log) {
            res.data.refund_fail_log.create_time = res.data.refund_fail_log
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(res.data.refund_fail_log.create_time * 1000)
                )
              : "-";
          }
          if (res.data.order_type === 3) {
            res.data.transferIncome = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 1) {
                      t.receivable_amount =
                        (Math.round(Number(t.receivable_amount) * 100) +
                          Math.round(Number(x.receivable_amount) * 100)) /
                        100;
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
            res.data.transferExpenditure = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 2) {
                      t.receivable_amount =
                        (Math.round(Number(t.receivable_amount) * 100) +
                          Math.round(Number(x.receivable_amount) * 100)) /
                        100;
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
            res.data.transferExpenditure = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 2) {
                      t.receivable_amount =
                        Number(t.receivable_amount) +
                        Number(x.receivable_amount);
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
          }
          this.mainData = res.data;
          this.voucher_url = res.data.refund_transfer
            ? res.data.refund_transfer.voucher_url
            : "";
          this.refundOriginalSupport = res.data.refund_original_support;
          this.refundHandleDelay = true;
          // 收支明细
          if (res.data.payment_type === 1) {
            getPaymentDetailApi({
              order_id: this.mainData.order_id,
            }).then((res) => {
              res.data.list.map((item) => {
                item.payment_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.payment_time * 1000)
                );
              });
              this.payDetailDialogData = res.data.list;
            });
          }
        }
      });
    },
    // 处理订单信息支付状态的文本类型
    handlePaymentStatus() {
      if (this.mainData.payment_type === 1) {
        // 原购买订单正在退单
        if (this.mainData.org_pay_order_chargeback_exist) {
          return "已付款 - 部分付款（退单中）";
        }
        switch (this.mainData.status) {
          case 1:
            return "待付款";
          case 2:
            return "已付款";
          case 4:
            if (this.mainData.cancel_type === 1) {
              return "已取消 - 系统取消";
            } else if (this.mainData.cancel_type === 2) {
              return "已取消 - 员工取消";
            } else if (this.mainData.cancel_type === 3) {
              return "已取消 - 部分付款（订单退款）";
            }
            return "已取消";
          case 5:
            return "已付款 - 部分付款";
        }
      }
      if (this.mainData.payment_type === 2) {
        if (this.mainData.refund_failed) {
          return "退款失败";
        }
        switch (this.mainData.status) {
          case 1:
            return "退款中";
          case 2:
            return "退款成功";
          case 3:
            return "已废除";
          case 4:
            return "已取消";
        }
      }
      return "-";
    },
    Order(id) {
      if (id === 0) {
        return false;
      }
      this.$router.push({
        name: "approveLogDetail",
        query: {
          id: String(id),
        },
      });
    },

    chooseRefundType() {
      this.refundDialogVisible = true;
      let date = new Date();
      let year = date.getFullYear();
      let month = String(date.getMonth()).padStart(2, 0);
      let day = String(date.getDate()).padStart(2, 0);
      if (Number(month) === 1) {
        year = year - 1;
        month = 12;
      }
      this.refundReasonDate = `${year}年${month}月${day}号`;
      if (!this.refundOriginalSupport) {
        this.refundDialogForm = {
          refund_method: 2,
          ...this.mainData.refund_transfer,
        };
        return;
      }
      if (this.mainData.refund_transfer) {
        this.refundDialogForm = {
          refund_method: 1,
          ...this.mainData.refund_transfer,
        };
      }
    },
    chooseRefundTypeSubmit() {
      /*
    退款时，假如退款内容支持原路退回，则订单创建后refund_method为1，银行卡信息不需要填，在退款处理时可以转为手动转账
    假如不支持，则改为手动转账，需要填写银行卡信息，refund_method为2
    旧支付流程的话，refund_method为0
    */

      if (this.refundDialogForm.refund_method === 1) {
        refundOriginalBackApi({
          refund_order_id: this.mainData.order_id,
        }).then((res) => {
          if (res.error_code === 0) {
            // this.$message({
            //   type: "success",
            //   message: "提交成功",
            // });
          } else {
            console.log("原路退回", res);
          }

          // 轮询查询退款状态
          this.refundDialogVisible = false;
          const shadow = this.$loading({
            lock: true,
            text: "正在查询退款状态，请勿关闭页面",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          const timer = setInterval(() => {
            checkRefundStatusApi({
              refund_order_id: this.mainData.order_id,
            })
              .then((res) => {
                if (res.data.payment_status === 3) {
                  this.$message({
                    type: "success",
                    message: "退款成功",
                  });
                  clearInterval(timer);
                  shadow.close();
                  this.init();
                }
                if (res.data.payment_status === 2) {
                  this.init();
                  this.$message({
                    type: "error",
                    message: "退款失败",
                  });
                  clearInterval(timer);
                  shadow.close();
                }
              })
              .catch(() => {
                this.$message({
                  type: "error",
                  message: "退款失败",
                });
                clearInterval(timer);
                shadow.close();
              });
          }, 1500);
        });
      }
      if (this.refundDialogForm.refund_method === 2) {
        if (!this.voucherDialogForm.image_key) {
          this.$message({
            type: "warning",
            message: "请先上传凭证图片",
          });
          return false;
        }
        uploadRefundVoucherApi({
          refund_order_id: this.mainData.order_id,
          voucher: this.voucherDialogForm.image_key,
        }).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: "退款成功",
            });
            this.init();
            this.refundDialogVisible = false;
            this.handleVoucherDialogClose();
            this.$router.push({
              name: "approveLog",
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },
    handleVoucherDialogClose() {
      this.voucherDialogForm = {
        image_key: "",
        image_url: "",
      };
    },
    handleVoucherDialogSubmit() {
      if (!this.voucherDialogForm.image_key) {
        this.$message({
          type: "warning",
          message: "请先上传凭证图片",
        });
        return false;
      }
      uploadRefundVoucherApi({
        refund_order_id: this.mainData.order_id,
        voucher: this.voucherDialogForm.image_key,
      }).then(() => {
        this.$message({
          type: "success",
          message: "退款成功",
        });
        this.handleVoucherDialogClose();
        this.$router.push({
          name: "approveLog",
        });
      });
    },
    handleBack() {
      //   this.$router.push({
      //     name: "approveLog",
      //   });
      this.$router.go(-1);
    },
    // 订单详情，跳转到原订单(购买课程订单)详情页，携带了 approveId，避免返回丢失退课订单详情页
    toOrderDetail(type, val) {
      let query = {};
      if (type === "no") {
        query.ono = val;
      }
      if (type === "id") {
        query.id = val;
      }
      if (this.mainData.payment_type === 2) {
        query.approveId = this.$route.query.id;
      }
      this.$router.push({
        name: "orderManageDetail",
        query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.detail-head {
  display: flex;
  margin: 16px 72px;
}
.approve-wrap {
  flex: 3;
  position: relative;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  .status-tag {
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .approve-title {
    height: 42px;
    line-height: 42px;
    padding: 0 22px;
    color: #5c5d5e;
    font-size: 14px;
    font-weight: bold;
    &.wait {
      background-color: #ffeff0;
    }
    &.cancel {
      background-color: #fff5e3;
    }
    &.pass {
      background-color: #e6faf6;
    }
    &.reject {
      background-color: #f2f6fa;
    }
  }
  .approve-content {
    flex: 1;
    padding: 19px 22px 50px 22px;
    border: 1px solid #e1e5e9;
    border-top: 0;
    position: relative;
    .rows {
      .row {
        position: relative;
        margin-bottom: 8px;
        padding-bottom: 8px;
        &::after {
          content: "";
          position: absolute;
          top: 26px;
          left: 9px;
          bottom: 0;
          border-right: 1px solid #e7e8ea;
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
        .title {
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 18px;
          color: #5c5d5e;
          margin-bottom: 8px;
          &.bold {
            font-weight: bold;
          }
          .icon {
            margin-right: 10px;
          }
          .border {
            margin: 0 6px;
            color: #e7e8ea;
          }
          .status {
            margin-left: 6px;
          }
        }
        .time {
          margin-left: 28px;
          font-size: 12px;
          color: #adaeae;
          line-height: 14px;
        }
        .desp {
          margin-top: 8px;
          margin-left: 28px;
          color: #5c5d5e;
          line-height: 14px;
          font-size: 12px;
          .el-image {
            vertical-align: text-top;
            width: 100px;
          }
        }
      }
    }
    .fail-log-wrap {
      font-size: 12px;
      line-height: 24px;
      color: #5c5d5e;
      margin-left: 12px;
      padding: 0 16px;
      margin-bottom: 8px;
    }
    .btns {
      position: absolute;
      bottom: 10px;
      left: 49px;
      .btn {
        width: 46px;
        text-align: center;
        margin-right: 20px;
      }
    }
  }
}
.order-block {
  border: 1px solid #d9dadb;
  padding: 26px;
  margin: 0 72px 10px 72px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 21px;
  }
  .pay-time {
    color: #5c5d5e;
    display: flex;
    line-height: 28px;
    .label {
      min-width: 70px;
    }
  }
  .item {
    display: flex;
    line-height: 28px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 70px;
    }
    .content {
      flex: 1;
      .box {
        display: inline-block;
        .text {
          border-right: 1px solid #e7e8ea;
          padding-right: 8px;
          margin-right: 8px;
        }
        &:last-child {
          .text {
            border: none;
          }
        }
      }
    }
  }
}
.order-wrap {
  flex: 2;
  display: flex;
  flex-direction: column;

  .order-title {
    height: 42px;
    line-height: 42px;
    font-weight: bold;
    padding: 0 21px;
    color: #07d1aa;
    font-size: 14px;
    background-color: #f2f6fa;
    position: relative;
    display: flex;
    &.limit {
      display: block;
      .text {
        margin-right: 24px;
      }
    }
    .text {
      flex: 1;
    }
    .payment-status {
      font-weight: normal;

      .repeal {
        position: absolute;
        top: 14px;
        right: 14px;
      }
    }
  }
  .order-content {
    flex: 1;
    padding: 19px 20px;
    border: 1px solid #e1e5e9;
    border-top: 0;
    .user {
      font-size: 16px;
      color: #5c5d5e;
      margin-bottom: 30px;
      line-height: 16px;
      .name {
        font-weight: bold;
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .form {
      .item {
        font-size: 14px;
        color: #5c5d5e;
        line-height: 14px;
        margin-bottom: 11px;
        display: flex;

        .label {
          width: 70px;
          text-align: right;
        }
        .value {
          flex: 1;
        }
      }
      .create-staff {
        margin-top: 30px;
      }
      .operator {
        margin-top: 30px;
      }
    }
  }
}
.cancel-order-wrap {
  margin: 20px 72px 20px 72px;
  padding: 26px 112px 12px 26px;
  border: 1px solid #d9dadb;
  border-radius: 4px;
  color: #5c5d5e;
  font-size: 12px;
  position: relative;
  line-height: 28px;
  .title {
    font-size: 14px;
    margin-bottom: 18px;
    font-weight: bold;
  }
  .info-box {
    margin-left: 50px;
  }
}
.table-wrap {
  margin: 0 72px;
  font-size: 12px;
  color: #5c5d5e;
  line-height: 42px;
  text-align: center;
  .th,
  .tr {
    display: flex;
    .td:nth-child(1) {
      flex: 1;
    }
    .td:nth-child(2) {
      flex: 1;
    }
    .td:nth-child(3) {
      flex: 1;
    }
    .td:nth-child(4) {
      flex: 1;
    }
    .td:nth-child(5) {
      flex: 1;
    }
    .td:nth-child(6) {
      flex: 1;
    }
    .td:nth-child(7) {
      flex: 1;
    }
  }
  .th {
    background-color: #f2f6fa;
    margin-bottom: 10px;
    .td {
      font-weight: bold;
    }
  }
  .tr {
    border-bottom: 1px solid #e1e5e9;
    &:last-child {
      border-bottom: 0;
    }
    .td {
    }
  }
  .item {
    margin-bottom: 10px;
    border: 1px solid #e1e5e9;
    .title {
      padding-left: 28px;
      font-weight: bold;
      background: #f2f6fa;
      text-align: left;
    }
  }
}
.sum-wrap {
  text-align: right;
  margin: 24px 72px;
  font-size: 18px;
  color: #5c5d5e;
  .red {
    font-size: 22px;
    color: #f56c6c;
  }
}
.collection-detail {
  margin: 0 72px;
  .text {
    margin: 20px 0;
    font-size: 14px;
    font-weight: 700;
    color: #5c5d5e;
  }
}
.pay-info {
  border-top: 1px solid #e7e8ea;
  margin: 0 72px;
  .list-item {
    padding: 0 20px;
    line-height: 24px;
    margin: 12px 0;
    font-size: 12px;
    color: #5c5d5e;
    .tag {
      border-right: 1px solid #e7e8ea;
      padding-right: 8px;
      margin-right: 8px;
      &:last-child {
        border-right: none;
      }
    }
  }
  .total-wrap {
    font-size: 12px;
    color: #5c5d5e;
    padding: 20px 0;

    .label {
      display: inline-block;
      vertical-align: top;
    }
    .wrap {
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      padding: 18px 0;
      display: inline-flex;
      .part {
        padding: 0 20px;
        align-items: flex-start;
        p {
          margin-right: 20px;
          &:last-child {
            margin-right: 0px;
          }
        }
        &:first-child {
          border-right: 1px solid #e7e8ea;
        }
      }
    }
  }
}
.handle-refund {
  .refund-form {
    padding: 0 35px;
    /deep/.refund-radio {
      .el-radio-group {
        width: 100%;
        display: flex;
        .el-radio-button {
          flex: 1;
          .el-radio-button__inner {
            width: 100% !important;
          }
        }
      }
    }
    .refund-reason {
      padding: 0 5px;
      margin-top: 25px;
      .reason-item {
        margin-bottom: 13px;
        &:last-child {
          margin-bottom: 0;
        }
        .reason-order {
          display: inline-block;
          height: 16px;
          width: 16px;
          border-radius: 50%;
          text-align: center;
          line-height: 16px;
          background: rgba(194, 195, 196, 0.3);
          margin-right: 8px;
        }
      }
    }
    .voucher-uploader {
      margin-top: 25px;
      width: 300px;
      height: 170px;
      border: 1px solid rgba(231, 232, 234, 1);
      border-radius: 4px;
      overflow: hidden;
      font-size: 0;
      text-align: center;
      img {
        // width: 300px;
        height: 170px;
      }
    }
  }
  .bottom-btns {
    text-align: right;
    margin-top: 25px;
  }
}

.footer {
  display: flex;
  padding: 20px 0;
  border-top: 1px solid #e7e8ea;
  margin: 0px 72px 0 72px;
  .block {
    flex: 1;
  }
  .disable {
    cursor: not-allowed !important;
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
